<template>
    <div>
        <limitless-page-header :loading="busy_loading" :title="'Ladda upp'" sub-title="Uppladdning">
            <template #header-elements>
                <limitless-page-header-button url="/documents" icon="icon-circle-left2">Tillbaka</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <div class="form-group" style="width: 300px;">
                <v-select
                    v-model="meta.document_category_id"
                    :options="categories"
                    label="name"
                    :reduce="opt => opt.id"
                    placeholder="Välj kategori!"
                />
            </div>
            <multiple-file-uploader url="/vue/documents/upload" :meta="meta" :disabled="!(meta.document_category_id > 0)" :message="(!(meta.document_category_id > 0) ? 'Välj kategori innan du startar uppladdningen!' : '')"></multiple-file-uploader>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import MultipleFileUploader from '@components/MultipleFileUploader';
import vSelect from 'vue-select';
import apiClient from '@services/ApiClient';

export default {
    name: 'DocumentUpload',
    components: {
        MultipleFileUploader,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        vSelect,
    },
    data: () => ({
        meta: {
            document_category_id: '',
        },
        categories: [],
    }),
    mounted() {
        this.getCategories();
    },
    methods: {
        getCategories() {
            apiClient.get('/vue/documents/categories/table').then((res) => {
                this.categories = res.data.data;
            });
        },
    },
};

</script>
